import { render } from "./CourseTermDrawer.vue?vue&type=template&id=91a02cb6&ts=true"
import script from "./CourseTermDrawer.vue?vue&type=script&lang=ts"
export * from "./CourseTermDrawer.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\iflam\\OneDrive\\নথিসমূহ\\tms-next\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__